import { render } from "./KpiTemplatesManagement.vue?vue&type=template&id=2cc31dd4&scoped=true"
import script from "./KpiTemplatesManagement.vue?vue&type=script&lang=js"
export * from "./KpiTemplatesManagement.vue?vue&type=script&lang=js"

import "./KpiTemplatesManagement.vue?vue&type=style&index=0&id=2cc31dd4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cc31dd4"]])

export default __exports__